// extracted by mini-css-extract-plugin
export default {"viewMore":"button_viewMore__d00At","viewMoreButton":"button_viewMoreButton__nE5Lf"};